import { gql } from '@apollo/client';
import ErrorResultFragment from "../../../fragments/ErrorResult";

const UPDATE_WORKSPACE = gql`
  mutation UpdateWorkspace($details: WorkspaceDetailsInput!) {
    companyAdminContext {
      companyWorkspaces {
        updateWorkspace(details: $details) {
          details {
            description
            icon
            iconColor
            iconImageUrl
            name
            networkId
            orderGroupId
            orderGroupOwnerName
            owner {
              company
              userId
              username
            }
            siteId
            storage
          }
          errorResult {
            ...ErrorResultFields
          }
          success
        }
      }
    }
  }
  ${ErrorResultFragment}
`;

export default UPDATE_WORKSPACE;
